import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './watcher_creation_form.module.scss';
import { TextButton } from '../../../../components/button';
import { Loader } from '../../../../components/loader/Loader';

type Props = {
  cancelButton: {
    callback: (event: React.MouseEvent<HTMLButtonElement>) => void;
  };
  validateButton: {
    callback: (event: React.FormEvent<HTMLFormElement>) => void;
    isLoading: boolean;
  };
};

export function WatcherCreationForm({ cancelButton, validateButton }: Props) {
  return (
    <form onSubmit={validateButton.callback} className={styles.form}>
      <div className={styles.cancel}>
        <TextButton onClick={cancelButton.callback}>
          <FormattedMessage id="search/components/search-decision-watcher/form/WatcherCreationForm.tsx/1" />
        </TextButton>
      </div>

      <button
        className={classNames('button primary', styles.submit)}
        disabled={validateButton.isLoading}
        type="submit"
        name="confirm-add-watcher"
      >
        {validateButton.isLoading && (
          <span className={styles.loading}>
            <Loader size={18} color="#ffffff" />
          </span>
        )}
        <FormattedMessage id="search/components/search-decision-watcher/form/WatcherCreationForm.tsx/2" />
      </button>
    </form>
  );
}
